import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * EmergencyMedicine icon
 *
 * @category Medical
 */
const EmergencyMedicine = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.45 14.767c-1.01-1.23-2.87-3.22-3.87-4.32-.94-1.15-3.7.46-3.39-1.91.08-.62.21-1.68-.7-1.66-2.48.04-4.96 0-7.44 0H7.18c-.4 0-2.21-.29-2.43.18-.03.06-.03.13-.03.19.01 2.94 0 5.89 0 8.83-.01 2 0 4.88 0 6.42 0 .29-.04.38.43.4.4.02 1.09-.03 1.46.17.61.35.74 1.14 1.39 1.55 1.32 1.08 3.52.62 4.31-.84.27-.46.48-.94 1.12-.88h4.73c.31 0 .52.02.72.24 1.03 2.34 4.15 2.95 5.53.51.29-.6.84-.88 1.43-1.1 1.5-.98.81-1.94.96-3.78-.09-1.29.25-2.79-.31-3.9l-.06-.1zm-16.72 9.48c-2.2-.04-2.67-3.27-.53-3.91 2.93-.75 3.63 3.68.65 3.91zm-.1-4.95c-1.01.06-2.02.73-2.47 1.65-.11.21-.26.43-.42.6-1.62 1.24-.83-2-1-2.87.02-3.26-.05-6.96.02-10.18 0-.39.19-.57.58-.57 3.59-.06 7.7.01 11.27-.02.79-.11.63.41.66 1.07.01 2.58 0 9.49-.01 12.46-.13.31-.01.38-.55.44-1.41-.09-3.41.2-4.67-.12-.67-.48-.77-1.51-1.59-1.94-.52-.36-1.22-.53-1.67-.53h-.14zm12.12 4.95c-2.2-.04-2.67-3.27-.53-3.91 2.93-.75 3.63 3.68.65 3.91zm3.42-2.59c-.33-.04-.56-.43-.76-.71-.84-1.6-3.08-2.03-4.46-.89-1.12 1.02-.6-.6-.71-1.7.03-1.82-.08-6.32.05-7.31.35-.43 1.24-.24 1.88-.2.52.09.88.45 1.22.81.6.73 2.05 2.17 2.48 2.89.03.09.01.15-.06.2-.68.36-3.21-.42-3.01.81.1.3.71.3 1.05.3.78.06 2.03-.16 2.68.17.15.1.22.27.26.5.08 1.1 0 2.37.03 3.46-.02.67.11 1.45-.53 1.67z"
        />
        <path
          fill="currentColor"
          d="M12.65 12.124a1 1 0 0 0 1 1h1.005a.5.5 0 0 1 0 1H13.65a1 1 0 0 0-1 1v1.004a.5.5 0 0 1-1 0v-1.004a1 1 0 0 0-1-1h-.995a.5.5 0 0 1 0-1h.995a1 1 0 0 0 1-1v-.995a.5.5 0 1 1 1 0z"
        />
      </svg>
    );
  }
);

EmergencyMedicine.displayName = 'EmergencyMedicine';

export { EmergencyMedicine };
